import { render, staticRenderFns } from "./SetHeightDuration.vue?vue&type=template&id=5b61408c&scoped=true&"
import script from "./SetHeightDuration.vue?vue&type=script&lang=js&"
export * from "./SetHeightDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b61408c",
  null
  
)

export default component.exports